import axios, {AxiosInstance} from "axios";
import {API_URL, API_KEY, API_SECRET, API_USERNAME, API_PASSWORD} from '../core/constants';

/**
 * Interface for axios auth
 */
interface IAuthParameters {
  username:string,
  password:string
}

const auth:IAuthParameters = {
  username: API_USERNAME,
  password: API_PASSWORD
}

const oauth:IAuthParameters = {
  username: API_KEY,
  password: API_SECRET
}

class Requests {

  public api:AxiosInstance;

  constructor(){
    // create API base
    this.api = axios.create({
      baseURL: `${API_URL}/wp-json`
    })

    // bind 'this' to get access to API instance
    this.getAllData = this.getAllData.bind(this)
    this.getManagedData = this.getManagedData.bind(this)
    this.createView = this.createView.bind(this)
    this.getView = this.getView.bind(this)
    this.getOptions = this.getOptions.bind(this)
    this.deleteView = this.deleteView.bind(this)
    this.createFormEntry = this.createFormEntry.bind(this)
  }

  /**
   * gets all data required to start building experiences
   */
  public async getAllData(){
    return await Promise.all([
      this.api.get("/wp/v2/factoid?per_page=200"),
      this.api.get("/wp/v2/classes?per_page=100"),
      this.api.get("/wp/v2/business_line?per_page=100"),
      this.api.get("/wp/v2/location?per_page=100")
    ])
  }

  /**
   * Gets all the data required to manage views
   */
  public async getManagedData(){
    return await Promise.all([
      this.api.get('/wp/v2/view'),
      this.api.get('/gf/v2/forms/1/entries', { auth: oauth })
    ])
  }

  public async createView(data:object){
    return await this.api.post(`/wp/v2/view`, data, { auth })
  }

  /**
   * Gets the View data for the landing page
   * @param id the ID of the view to get
   */
  public async getView(id:string){
    return await this.api.get(`/wp/v2/view/${ id }`)
  }

  /**
   * Gets the Options data for the success page
   */
  public async getOptions(){
    return await this.api.get(`/acf/v3/options/options`)
  }

  /**
   * Deletes a view
   * @param id the ID of the view to delete
   */
  public async deleteView(id:string){
    return await this.api.delete(`/wp/v2/view/${id}`, { auth })
  }

  /**
   * Updates a view with ACF data.
   * @param id view ID to update
   * @param data data to push through
   */
  public async updateViewACF(id:string, data:object){
    return await this.api.post(`/acf/v3/view/${id}`, data, {auth})
  }

  /**
   * Creates a form entry
   * @param data form data to post
   */
  public async createFormEntry(data:object){
    return await this.api.post('/gf/v2/forms/1/submissions', data, {auth: oauth})
  }


}

export default new Requests();


// WEBPACK FOOTER //
// ./src/lib/requests.ts